import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.labEdit || initialState;

export const selectCountries = createSelector(
  [selectDomain],
  (state) => state.countries
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectCities = createSelector(
  [selectDomain],
  (state) => state.cities
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectLabDetails = createSelector([selectDomain], (state) => {
  const labDetails = state.labDetails;
  if (labDetails) {
    return {
      ...labDetails,
      address: {
        ...labDetails.address,
        state: labDetails?.address?.state?._id,
        country: labDetails?.address?.country?._id,
        city: labDetails?.address?.city?._id,
      },
      operatingStates: labDetails.operatingStates.map((state) => state._id),
    };
  }
});
